import COLORS from 'pared/constants/colors'

import { IConfigsType } from '../../types'

const dhWbGuestConfig: IConfigsType = {
  dh_wb: {
    '/:brand/corporate_guest': {
      variables: ['date', 'corporateGroup', 'discountType', 'lastTimeRange'],
      groupFilter: {
        api: 'corporateFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'last_week',
          'this_week',
          'yesterday',
          'trailing_7_days',
          'trailing_90_days',
          'custom',
        ],
      },
      listLocationGroupGuestKpis: {
        type: 'list',
        api: 'dhWbListLocationGroupGuestKpis',
        title: 'Systemwide Guest',
        fieldWidth: '160px',
        fields: [
          {
            top: 'Google Rating',
            content: {
              key: 'googleRating',
              decimal: 1,
            },
            bottom: {
              key: 'googleRatingCount',
              format: '<%- valueStr + " ratings" %>',
            },
          },
          {
            top: 'Yelp Rating',
            content: {
              key: 'yelpRating',
              decimal: 1,
            },
            bottom: {
              key: 'yelpRatingCount',
              format: '<%- valueStr + " ratings" %>',
            },
          },
          {
            top: 'Delivery Rating',
            content: {
              key: 'deliveryAvgCustomerReviewScoreDoordash',
              decimal: 1,
            },
            bottom: {
              key: 'deliveryReviewedOrderCountDoordash',
              format: '<%- valueStr + " ratings" %>',
            },
            hide: '<%- parseInt(date?.getInfo(0).businessYear, 10) > 2025 %>',
          },
          {
            top: 'Delivery Like and Love %',
            content: {
              key: 'deliveryCustomerPositiveRatingCountPercentDoordash',
              decimal: 1,
            },
            bottom: {
              key: 'deliveryReviewedOrderCountDoordash',
              format: '<%- valueStr + " ratings" %>',
            },
            width: '200px',
            hide: '<%- parseInt(date?.getInfo(0).businessYear, 10) < 2026 %>',
          },
        ],
      },
      listLocationGroupQualtricsKpisPartOne: {
        type: 'list',
        api: 'dhWbListLocationGroupGuestKpis',
        title: 'Qualtrics',
        fieldWidth: '160px',
        fields: [
          {
            top: 'OSAT',
            content: {
              key: 'qualtricsOsatPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsOsatTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Order Accuracy',
            content: {
              key: 'qualtricsOrderAccuracyPercent',
              decimal: 1,
              color:
                '<%- value > 95 ? "green" : value > 90 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsOrderAccuracyTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Quality of Food',
            content: {
              key: 'qualtricsQualityOfFoodPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsQualityOfFoodTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Menu Options',
            content: {
              key: 'qualtricsMenuOptionsPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsMenuOptionsTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Value',
            content: {
              key: 'qualtricsValuePercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsValueTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
        ],
      },
      listLocationGroupQualtricsKpisPartTwo: {
        type: 'list',
        api: 'dhWbListLocationGroupGuestKpis',
        margin: '0',
        fieldWidth: '160px',
        fields: [
          {
            top: 'Ease of Ordering',
            content: {
              key: 'qualtricsEaseOfOrderingPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsEaseOfOrderingTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Employee Friendliness',
            content: {
              key: 'qualtricsEmployeeFriendlinessPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsEmployeeFriendlinessTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Speed of Service',
            content: {
              key: 'qualtricsSpeedOfServicePercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsSpeedOfServiceTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Cleanliness',
            content: {
              key: 'qualtricsCleanlinessPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsCleanlinessTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Drive-thru Wait Time',
            content: {
              key: 'qualtricsDriveThruWaitTimePercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsDriveThruWaitTimeTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
        ],
      },
      ratingTrendFilters: {
        type: 'grid',
        children: {
          title: {
            type: 'title',
            title: 'Ratings Trend',
          },
          columns: {
            type: 'select',
            value: 'lastTimeRange.value',
            onChange: 'lastTimeRange.onChange',
            options: 'lastTimeRange.options',
            label: ' ',
          },
        },
      },
      ratingsTrendChart: {
        type: 'line-chart',
        api: 'dhWbTrendLocationGroupGuest',
        width: 1100,
        height: 500,
        label: 'date',
        datasets: [
          {
            key: 'yelpRating',
            label: 'Yelp',
            borderColor: COLORS.Pomodoro,
            backgroundColor: COLORS.Pomodoro,
            chartType: 'line',
            decimal: 1,
          },
          {
            key: 'googleRating',
            label: 'Google',
            borderColor: COLORS.Mango,
            backgroundColor: COLORS.Mango,
            chartType: 'line',
            decimal: 1,
          },
          {
            key: 'deliveryAvgCustomerReviewScoreDoordash',
            label: 'Delivery Combined Star Rating',
            borderColor: COLORS.Chalkboard,
            backgroundColor: COLORS.Chalkboard,
            chartType: 'line',
            decimal: 1,
            hidden: true,
          },
          {
            key: 'deliveryCustomerPositiveRatingCountPercentDoordash',
            label: 'Delivery Like and Love %',
            borderColor: COLORS.Basil,
            backgroundColor: COLORS.Basil,
            chartType: 'line',
            decimal: 1,
            yAxisID: 'y1',
          },
          {
            key: 'qualtricsOsatPercent',
            label: 'OSAT',
            borderColor: COLORS.Expo,
            backgroundColor: COLORS.Expo,
            chartType: 'line',
            decimal: 1,
            yAxisID: 'y1',
          },
        ],
        scaleTypes: {
          y: {
            type: 'number',
            decimal: 1,
          },
          y1: {
            type: 'percent',
            decimal: 1,
          },
        },
        options: {
          plugins: {
            legend: {
              display: true,
            },
          },
          scales: {
            y: {},
            y1: {
              position: 'right',
              grid: {
                drawOnChartArea: false,
              },
            },
          },
        },
      },
      breakdownByStore: {
        type: 'table-v2',
        title: 'Social Breakdown By Store',
        titleMargin: '30px 0',
        api: 'dhWbListLocationGroupGuestData',
        sorting: [
          {
            id: 'qualtricsOsatPercent',
            desc: true,
          },
        ],
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: '<%- JSON(corporateGroup?.tableColumns) %>',
            hide: '<%- _.isUndefined(corporateGroup) %>',
            sortable: true,
          },
          {
            key: 'qualtrics',
            title: 'Qualtrics',
            align: 'center',
            children: [
              {
                key: 'qualtricsOsatPercent',
                title: 'OSAT',
                width: '175px',
                align: 'center',
                sortable: true,
                decimal: 1,
                background: {
                  colors: [
                    'rgb(222, 157, 155)',
                    'rgb(251, 230, 162)',
                    'rgb(220, 233, 213)',
                  ],
                  range: [0, 1, 2],
                  value:
                    '<%- values.qualtricsOsatPercent > 80 ? 2 : values.qualtricsOsatPercent > 70 ? 1 : 0 %>',
                },
              },
              {
                key: 'qualtricsOrderAccuracyPercent',
                title: 'Order Accuracy',
                width: '175px',
                align: 'center',
                sortable: true,
                decimal: 1,
                background: {
                  colors: [
                    'rgb(222, 157, 155)',
                    'rgb(251, 230, 162)',
                    'rgb(220, 233, 213)',
                  ],
                  range: [0, 1, 2],
                  value:
                    '<%- values.qualtricsOrderAccuracyPercent > 95 ? 2 : values.qualtricsOrderAccuracyPercent > 90 ? 1 : 0 %>',
                },
              },
              {
                key: 'qualtricsQualityOfFoodPercent',
                title: 'Quality of Food',
                width: '175px',
                align: 'center',
                sortable: true,
                decimal: 1,
                background: {
                  colors: [
                    'rgb(222, 157, 155)',
                    'rgb(251, 230, 162)',
                    'rgb(220, 233, 213)',
                  ],
                  range: [0, 1, 2],
                  value:
                    '<%- values.qualtricsQualityOfFoodPercent > 80 ? 2 : values.qualtricsQualityOfFoodPercent > 70 ? 1 : 0 %>',
                },
              },
              {
                key: 'qualtricsMenuOptionsPercent',
                title: 'Menu Options',
                width: '175px',
                align: 'center',
                sortable: true,
                decimal: 1,
                background: {
                  colors: [
                    'rgb(222, 157, 155)',
                    'rgb(251, 230, 162)',
                    'rgb(220, 233, 213)',
                  ],
                  range: [0, 1, 2],
                  value:
                    '<%- values.qualtricsMenuOptionsPercent > 80 ? 2 : values.qualtricsMenuOptionsPercent > 70 ? 1 : 0 %>',
                },
              },
              {
                key: 'qualtricsValuePercent',
                title: 'Value',
                width: '175px',
                align: 'center',
                sortable: true,
                decimal: 1,
                background: {
                  colors: [
                    'rgb(222, 157, 155)',
                    'rgb(251, 230, 162)',
                    'rgb(220, 233, 213)',
                  ],
                  range: [0, 1, 2],
                  value:
                    '<%- values.qualtricsValuePercent > 80 ? 2 : values.qualtricsValuePercent > 70 ? 1 : 0 %>',
                },
              },
              {
                key: 'qualtricsEaseOfOrderingPercent',
                title: 'Ease of Ordering',
                width: '175px',
                align: 'center',
                sortable: true,
                decimal: 1,
                background: {
                  colors: [
                    'rgb(222, 157, 155)',
                    'rgb(251, 230, 162)',
                    'rgb(220, 233, 213)',
                  ],
                  range: [0, 1, 2],
                  value:
                    '<%- values.qualtricsEaseOfOrderingPercent > 80 ? 2 : values.qualtricsEaseOfOrderingPercent > 70 ? 1 : 0 %>',
                },
              },
              {
                key: 'qualtricsEmployeeFriendlinessPercent',
                title: 'Employee Friendliness',
                width: '175px',
                align: 'center',
                sortable: true,
                decimal: 1,
                background: {
                  colors: [
                    'rgb(222, 157, 155)',
                    'rgb(251, 230, 162)',
                    'rgb(220, 233, 213)',
                  ],
                  range: [0, 1, 2],
                  value:
                    '<%- values.qualtricsEmployeeFriendlinessPercent > 80 ? 2 : values.qualtricsEmployeeFriendlinessPercent > 70 ? 1 : 0 %>',
                },
              },
              {
                key: 'qualtricsSpeedOfServicePercent',
                title: 'Speed of Service',
                width: '175px',
                align: 'center',
                sortable: true,
                decimal: 1,
                background: {
                  colors: [
                    'rgb(222, 157, 155)',
                    'rgb(251, 230, 162)',
                    'rgb(220, 233, 213)',
                  ],
                  range: [0, 1, 2],
                  value:
                    '<%- values.qualtricsSpeedOfServicePercent > 80 ? 2 : values.qualtricsSpeedOfServicePercent > 70 ? 1 : 0 %>',
                },
              },
              {
                key: 'qualtricsCleanlinessPercent',
                title: 'Cleanliness',
                width: '175px',
                align: 'center',
                sortable: true,
                decimal: 1,
                background: {
                  colors: [
                    'rgb(222, 157, 155)',
                    'rgb(251, 230, 162)',
                    'rgb(220, 233, 213)',
                  ],
                  range: [0, 1, 2],
                  value:
                    '<%- values.qualtricsCleanlinessPercent > 80 ? 2 : values.qualtricsCleanlinessPercent > 70 ? 1 : 0 %>',
                },
              },
              {
                key: 'qualtricsDriveThruWaitTimePercent',
                title: 'Drive-thru Wait Time',
                width: '175px',
                align: 'center',
                sortable: true,
                decimal: 1,
                background: {
                  colors: [
                    'rgb(222, 157, 155)',
                    'rgb(251, 230, 162)',
                    'rgb(220, 233, 213)',
                  ],
                  range: [0, 1, 2],
                  value:
                    '<%- values.qualtricsDriveThruWaitTimePercent > 80 ? 2 : values.qualtricsDriveThruWaitTimePercent > 70 ? 1 : 0 %>',
                },
              },
            ],
          },
          {
            key: 'yelpRating',
            title: 'Yelp',
            width: '75px',
            align: 'center',
            sortable: true,
            decimal: 1,
          },
          {
            key: 'googleRating',
            title: 'Google',
            width: '100px',
            align: 'center',
            sortable: true,
            decimal: 1,
          },
          {
            key: 'deliveryAvgCustomerReviewScoreDoordash',
            title: 'Delivery Combined Star Rating',
            width: '100px',
            align: 'center',
            sortable: true,
            decimal: 1,
            hide: '<%- parseInt(date?.getInfo(0).businessYear, 10) > 2025 %>',
          },
          {
            key: 'deliveryCustomerPositiveRatingCountPercentDoordash',
            title: 'Delivery Like and Love %',
            width: '100px',
            align: 'center',
            sortable: true,
            decimal: 1,
            hide: '<%- parseInt(date?.getInfo(0).businessYear, 10) < 2026 %>',
          },
        ],
      },
      chatbox: {
        type: 'chatbox-v2',
        agentCode: 'systemwide-guest',
        sendStoreId: false,
      },
    },
    '/:brand/guest': {
      variables: ['date', 'lastTimeRange'],
      guestTitle: {
        type: 'title',
        title: 'locationInfo',
        subTitle: 'storeSubtitle',
      },
      groupFilter: {
        api: 'locationFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'last_week',
          'this_week',
          'trailing_7_days',
          'trailing_90_days',
          'custom',
        ],
      },
      // FIXME: Need to change from SMG to Qualtrics
      // expoAi: {
      //   type: 'ai-summary-box',
      //   api: 'locationGuestAiSummary',
      // },
      listLocationGuestKpis: {
        type: 'list',
        api: 'dhWbListLocationGuestKpis',
        fieldWidth: '160px',
        fields: [
          {
            top: 'Google Rating',
            content: {
              key: 'googleRating',
              decimal: 1,
            },
            bottom: {
              key: 'googleRatingCount',
              format: '<%- valueStr + " ratings" %>',
            },
          },
          {
            top: 'Yelp Rating',
            content: {
              key: 'yelpRating',
              decimal: 1,
            },
            bottom: {
              key: 'yelpRatingCount',
              format: '<%- valueStr + " ratings" %>',
            },
          },
          {
            top: 'Delivery Rating',
            content: {
              key: 'deliveryAvgCustomerReviewScoreDoordash',
              decimal: 1,
            },
            bottom: {
              key: 'deliveryReviewedOrderCountDoordash',
              format: '<%- valueStr + " ratings" %>',
            },
            hide: '<%- parseInt(date?.getInfo(0).businessYear, 10) > 2025 %>',
          },
          {
            top: 'Delivery Like and Love %',
            content: {
              key: 'deliveryCustomerPositiveRatingCountPercentDoordash',
              decimal: 1,
            },
            bottom: {
              key: 'deliveryReviewedOrderCountDoordash',
              format: '<%- valueStr + " ratings" %>',
            },
            width: '200px',
            hide: '<%- parseInt(date?.getInfo(0).businessYear, 10) < 2026 %>',
          },
        ],
      },
      listLocationQualtricsKpisPartOne: {
        type: 'list',
        api: 'dhWbListLocationGuestKpis',
        title: 'Qualtrics',
        fieldWidth: '220px',
        fields: [
          {
            top: 'OSAT',
            content: {
              key: 'qualtricsOsatPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsOsatTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Order Accuracy',
            content: {
              key: 'qualtricsOrderAccuracyPercent',
              decimal: 1,
              color:
                '<%- value > 95 ? "green" : value > 90 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsOrderAccuracyTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Quality of Food',
            content: {
              key: 'qualtricsQualityOfFoodPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsQualityOfFoodTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Menu Options',
            content: {
              key: 'qualtricsMenuOptionsPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsMenuOptionsTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Value',
            content: {
              key: 'qualtricsValuePercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsValueTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
        ],
      },
      listLocationQualtricsKpisPartTwo: {
        type: 'list',
        api: 'dhWbListLocationGuestKpis',
        margin: '0',
        fieldWidth: '220px',
        fields: [
          {
            top: 'Ease of Ordering',
            content: {
              key: 'qualtricsEaseOfOrderingPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsEaseOfOrderingTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Employee Friendliness',
            content: {
              key: 'qualtricsEmployeeFriendlinessPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsEmployeeFriendlinessTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Speed of Service',
            content: {
              key: 'qualtricsSpeedOfServicePercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsSpeedOfServiceTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Cleanliness',
            content: {
              key: 'qualtricsCleanlinessPercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsCleanlinessTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
          {
            top: 'Drive-thru Wait Time',
            content: {
              key: 'qualtricsDriveThruWaitTimePercent',
              decimal: 1,
              color:
                '<%- value > 80 ? "green" : value > 70 ? colors.Mango : "red" %>',
            },
            bottom: {
              key: 'qualtricsDriveThruWaitTimeTotalSurveys',
              format: '<%- valueStr + " surveys" %>',
            },
          },
        ],
      },
      guestCommentTable: {
        type: 'table-v2',
        title: 'Guest Reviews',
        titleMargin: '30px 0',
        api: 'dhWbListLocationGuestCommentData',
        sorting: [
          {
            id: 'ratingScore',
            desc: true,
          },
        ],
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'reviewSource',
            title: 'Source',
            width: '100px',
            align: 'center',
          },
          {
            key: 'reviewContent',
            title: 'Review',
            width: '500px',
          },
          {
            key: 'ratingScore',
            title: 'Rating',
            width: '250px',
            sortable: true,
          },
          {
            key: 'date',
            title: 'Date',
            width: '150px',
            align: 'center',
          },
        ],
      },
      guestRatingTrendTimeRangeFilters: {
        type: 'grid',
        children: {
          title: {
            type: 'title',
            title: 'Guest Ratings',
          },
          columns: {
            type: 'select',
            value: 'lastTimeRange.value',
            onChange: 'lastTimeRange.onChange',
            options: 'lastTimeRange.options',
          },
        },
      },
      guestRatingTrendChart: {
        type: 'line-chart',
        api: 'dhWbTrendLocationGuestKpis',
        width: 1100,
        height: 350,
        label: 'date',
        datasets: [
          {
            key: 'deliveryAvgCustomerReviewScoreDoordash',
            label: 'Store Average Rating Stars',
            decimal: 2,
            hidden: true,
          },
          {
            key: 'systemwideDeliveryAvgCustomerReviewScoreDoordash',
            label: 'Systemwide Average Rating Stars',
            decimal: 2,
            hidden: true,
          },
          {
            key: 'deliveryCustomerPositiveRatingCountPercentDoordash',
            label: 'Store Like and Love %',
            decimal: 1,
            yAxisID: 'y1',
          },
          {
            key: 'systemwideDeliveryCustomerPositiveRatingCountPercentDoordash',
            label: 'Systemwide Average Like and Love %',
            decimal: 1,
            yAxisID: 'y1',
          },
        ],
        scaleTypes: {
          y: {
            type: 'number',
            decimal: 1,
          },
          y1: {
            type: 'percent',
            decimal: 1,
          },
        },
        options: {
          plugins: {
            legend: {
              display: true,
            },
          },
          scales: {
            y: {
              title: {
                text: 'Rating Starst',
              },
            },
            y1: {
              position: 'right',
              grid: {
                drawOnChartArea: false,
              },
            },
          },
        },
      },
      chatbox: {
        type: 'chatbox-v2',
        agentCode: 'store-guest',
        sendStoreId: true,
      },
      feV2ChatBox: {
        type: 'feV2-chatbox',
        agentType: 'location',
        hideFromNonExpoUsers: false,
        disableInputField: false,
        sendStoreId: true,
        description: 'Ask about guest satisfaction',
        bubblePrompts: [
          {
            id: 'guest-satisfaction',
            label: 'Summarize Guest Satisfaction',
            prompt: 'Show me the guest satisfaction for the trailing 8 weeks',
            params: {
              type: 'dateRange',
              dateRangeType: 'trailing_8weeks',
              periods: ['current'],
            },
            agentCode: 'prompt:guest-satisfaction',
            metrics: ['qualtrics_osat_percent'],
          },
        ],
      },
    },
  },
}

export default dhWbGuestConfig
